// In Accounts Summary page, odata component won't fill Account ID as Account ID doesn't exist
// But MT buggy implementation still need Account ID
export function getURLWithScope(pageContext, urlWithoutScope, isCustomerLevel = false) {
  return isCustomerLevel ?
    `Customers(${pageContext.CurrentCustomer.Id})/${urlWithoutScope}` :
    `Customers(${pageContext.CurrentCustomer.Id})/Accounts(${pageContext.CurrentAccount.Id})/${urlWithoutScope}`;
}
